import { createBrowserRouter } from "react-router-dom";
import PawanaCamping from "./Camping/Pawana";
import { Layout } from "./Layout";
import PanshetCamping from "./Camping/Panshet";
import ImageCarousel from "./ImageCarousel";
import ServicesData from "./ServicesData";
import ImageCard from "./ImageCard";
import PawanaNewYearCamping from "./Camping/NYC-Pawana";
import PanshetNewYearCamping from "./Camping/NYC-Panshet";
import Bhimashankar from "./SahydriTreks/Bhimashankar";
import CampAdvisory from "./Policies/CampAdvisory";
import TermsAndConditions from "./Policies/TermsAndConditions";
import HomePage from "./HomePage/HomePage";
import PackageInfo from "./PackageInfo/PackageInfo";
import NotFound from "./CommonUI/NotFound";
import TrekAdvisory from "./Policies/TrekAdvisory";
import Raireshwar from "./SahydriTreks/Raireshwar";
import AdraiJungle from "./SahydriTreks/AdraiJungle";
import CancellationPolicy from "./CommonUI/CancellationPolicy";
import VasotaFort from "./SahydriTreks/VasotaFort";
import Harichandragad from "./SahydriTreks/Harichandragad";
import Kalsubai from "./SahydriTreks/Kalsubai";
import ReverseWaterfallNaneghat from "./SahydriTreks/ReverseWaterfallNaneghat";
import KorigadFort from "./SahydriTreks/KorigadFort";
import KaluWaterfall from "./SahydriTreks/KaluWaterfall";
import Devkund from "./SahydriTreks/Devkund";
import SavlyaGhat from "./SahydriTreks/SavlyaGhat";
import Andharban from "./SahydriTreks/Andharban";
import TamhiniOffBeat from "./SahydriTreks/TamhiniOffBeat";
import TikonaFortPawanaCampingSunset from "./SahydriTreks/TikonaFortPawanaCampingSunset";
import VisapurFort from "./SahydriTreks/VisapurFort";
import NanemachiTrekSatsadaFalls from "./SahydriTreks/NanemachiTrekSatsadaFalls";
import KaroliValley from "./SahydriTreks/KaroliValley";
import GhangadFort from "./SahydriTreks/GhangadFort";
import TrekInfo from "./HomePage/TrekInfo";
import treks from "./Data/treks";
import VillasPage from "./Travel/VillasPage";
import TourPackagesPage from "./Travel/TourPackagesPage";
const Router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: "/", element: <HomePage /> },
        { path: "/learn-more", element: <PackageInfo /> },
        { path: "/camp-advisory", element: <CampAdvisory /> },
        { path: "/pawana-camping", element: <PawanaCamping /> },
        { path: "/panshet-camping", element: <PanshetCamping /> },
        { path: "/gallery", element: <ImageCarousel /> },
        { path: "/camping", element: <ImageCard /> },
        { path: "/villas", element: <VillasPage /> },
        { path: "/tour-packages", element: <TourPackagesPage /> },
        { path: "/services", element: <ServicesData /> },
        { path: "/nyc-pawana", element: <PawanaNewYearCamping /> },
        { path: "/nyc-panshet", element: <PanshetNewYearCamping /> },
        { path: "/terms-and-conditions", element: <TermsAndConditions /> },
        { path: "/bhimashankar-to-bhorgiri", element: <Bhimashankar /> },
        { path: "/raireshwar-fort", element: <Raireshwar /> },
        { path: "/adrai-jungle", element: <AdraiJungle /> },
        {
          path: "/reverse-waterfall-naneghat",
          element: <ReverseWaterfallNaneghat />,
        },
        { path: "/vasota-fort", element: <VasotaFort /> },
        { path: "/harichandragad", element: <Harichandragad /> },
        { path: "/kalsubai", element: <Kalsubai /> },
        { path: "/korigad-fort", element: <KorigadFort /> },
        { path: "/kalu-waterfall", element: <KaluWaterfall /> },
        { path: "/devkund", element: <Devkund /> },
        { path: "/savlya-ghat", element: <SavlyaGhat /> },
        { path: "/andharban", element: <Andharban /> },
        { path: "/tamhini-off-beat", element: <TamhiniOffBeat /> },
        {
          path: "/tikona-fort-pawana-camping-sunset",
          element: <TikonaFortPawanaCampingSunset />,
        },
        { path: "/visapur-fort", element: <VisapurFort /> },
        {
          path: "/nanemachi-trek-satsada-falls",
          element: <NanemachiTrekSatsadaFalls />,
        },
        { path: "/karoli-valley", element: <KaroliValley /> },
        { path: "/ghangad-fort", element: <GhangadFort /> },
        { path: "/SahyadriTreks", element: <TrekInfo treks={treks} /> },

        { path: "*", element: <NotFound /> },
        { path: "/trek-advisory", element: <TrekAdvisory /> },
        { path: "/cancellation-policy", element: <CancellationPolicy /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_startTransition: true,
    },
  },
);

export default Router;
